
import { Injectable } from '@angular/core';
import { Pescador } from './../../models/pescador';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS } from 'src/app/config/config';
import 'rxjs/add/operator/map';
import { SolicitanteService } from './solicitante.service';



@Injectable({
  providedIn: 'root'
})
export class PescadorService {


  totalListadoPescador: number = 0;

constructor( public http: HttpClient,
             public solicitanteService: SolicitanteService

             ) {

 }








 crearPescador( pescador: Pescador) {
  let url = URL_SERVICIOS + '/pescador';
  url += '?token=' + this.solicitanteService.token;

  return this.http.post( url, pescador);
}





nuestraTodosPescadores( valoID: string) {
  let url = URL_SERVICIOS + '/pescador/' + valoID;
 // let url = URL_SERVICIOS + '/pescador/' + this.tomaIDlocalstora();
  console.log ( url );
  return this.http.get( url)
  .map ( (resp: any) =>{
  this.totalListadoPescador = resp.contador;
  return resp.pescador; }
  );
}

tomaIDlocalstora() {
  return localStorage.getItem('idsolicitante');
}


realizaPagoStripe( token: string) {
 console.log (token);
}

processPayment(token: any, amount) {
  const payment = { token, amount };
  return 'hola';
  }


borraPescador(idpescador: string) {
  const url = URL_SERVICIOS + '/pescador/' + idpescador;
  return this.http.delete( url );
}




nuestraPescadorSeleccionado( valoID: string) {
  console.log ( valoID);
  const url = URL_SERVICIOS + '/pescador/unicopescador/' + valoID;
  console.log ( url );
  return this.http.get( url)
  .map ( (resp: any) =>{
  return resp.pescador; }
  );
}
}







